
import { css } from 'lit';
export default css`
pc-news-card pc-link{
    --link-font-weight:var(--fw-normal);
  }
  pc-news-card pc-link *{
    --link-font-weight:var(--fw-normal);
  }
  pc-news-card:hover *{
    color:var(--font-color);
  }
  pc-news-card:hover pc-rectangle{
    --rectangle-color:var(--primary-white);
  }

@media (min-width: 768px){
  pc-news-card:hover pc-link{
    --link-font-weight:var(--fw-normal);
  }
}
`;